import React,{useEffect} from "react";
import Cookies from "universal-cookie";

const ExitPopup = ({destinationUrl, setIsPopup}) => {
  const exitHandle = ()=>{
    setIsPopup(false)
  }
  
  return (
    <section className="exit_page">
        <div className="action_block">
          <h2>Are you sure you want to exit?</h2>
          <p>You'll be missing out on study abroad help & benefits</p>
          <div className="btn_group">
            <button type="button" onClick={exitHandle}>Cancel</button>
            <a href={destinationUrl}>Proceed</a>
          </div>
        </div>
    </section>  
  );
};

export default ExitPopup;
